// extracted by mini-css-extract-plugin
export default {"tab":"tab_tab__AXNqj","text":"tab_text__7EaYx","tab_active":"tab_tab_active__XMrxh"};